import { useState } from 'react'
import { Button, Skeleton } from '@mui/material'

import { useAccount } from 'src/hooks'

import { useStyles } from './styles'
import { EAccountSubscriptionPlans } from 'src/types'
import { BillingModal } from './billing-modal'
import { HelperWrapper } from 'src/components/helper-wrapper'

const BillingPlanMobile = () => {
  const classes = useStyles()
  const { data: account } = useAccount()
  const [open, setOpen] = useState(false)

  const handleModalOpen = () => {
    setOpen(true)
  }

  const handleModalClose = () => {
    setOpen(false)
  }

  if (!account) {
    return (
      <Skeleton
        width={'100% - 40px'}
        height={104}
        variant="rectangular"
        sx={{ borderRadius: '10px' }}
      />
    )
  }

  return (
    <>
      <div className={`${classes.itemBorder} ${classes.planWrapper}`}>
        <h3 className={classes.itemTitle}>
          <HelperWrapper t="billing-currently-on" />
        </h3>
        <div className={classes.planContentWrapper}>
          <h2 className={classes.planTitle}>{account.subscription_plan} Plan</h2>
          <Button
            onClick={handleModalOpen}
            disabled={
              account.subscription_plan === EAccountSubscriptionPlans.premium ||
              account.subscription_cancelled
            }
            variant="contained"
            className={classes.planButton}
          >
            <HelperWrapper t="upgrade-button-text" />
          </Button>
        </div>
      </div>
      <BillingModal onClose={handleModalClose} open={open} subscription_plan={null} />
    </>
  )
}

export { BillingPlanMobile }
